export var Literal = 'Literal';
export var Identifier = 'Identifier';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/expression/ast.js
// module id = 193
// module chunks = 0